<template>

  <el-card>

    <div slot="header">
      <h1>基础详情页</h1>
      <div class="header-index-content">
        <p>用于展示一些数据，无操作</p>
      </div>
    </div>

    <div class="detail-list-container">
      <detail-list title="退款详情">
        <detail-list-item term="取货单号">1000000000</detail-list-item>
        <detail-list-item term="状态">已取货</detail-list-item>
        <detail-list-item term="销售单号">987654321</detail-list-item>
        <detail-list-item term="子订单">1234567890</detail-list-item>
      </detail-list>
      <divider />
      <detail-list title="用户信息">
        <detail-list-item term="用户姓名">付小小</detail-list-item>
        <detail-list-item term="联系电话">18100000001</detail-list-item>
        <detail-list-item term="常用快递">菜鸟仓储</detail-list-item>
        <detail-list-item term="取货地址">浙江省杭州市西湖区万塘路19号</detail-list-item>
        <detail-list-item term="备注">无</detail-list-item>
      </detail-list>
      <divider />
      <div class="title">退货商品</div>
      <el-table class="table" :data="goodsData">
        <el-table-column prop="id" label="商品编号" />
        <el-table-column prop="name" label="商品名称" />
        <el-table-column prop="price" label="商品价格" :formatter="$tableHelper.fmts.price" />
        <el-table-column prop="num" label="商品数量" />
        <el-table-column prop="amount" label="总计" :formatter="$tableHelper.fmts.price" />
      </el-table>
    </div>

  </el-card>

</template>

<script>
const goodsData = [
  {
    id: '1234561',
    name: '矿泉水 550ml',
    barcode: '12421432143214321',
    price: '2.00',
    num: '1',
    amount: '2.00'
  },
  {
    id: '1234562',
    name: '凉茶 300ml',
    barcode: '12421432143214322',
    price: '3.00',
    num: '2',
    amount: '6.00'
  },
  {
    id: '1234563',
    name: '好吃的薯片',
    barcode: '12421432143214323',
    price: '7.00',
    num: '4',
    amount: '28.00'
  },
  {
    id: '1234564',
    name: '特别好吃的蛋卷',
    barcode: '12421432143214324',
    price: '8.50',
    num: '3',
    amount: '25.50'
  }
]
export default {
  data() {
    return {
      goodsData
    }
  }
}
</script>
